import { render, staticRenderFns } from "./StepperPasoDescuentos.vue?vue&type=template&id=a034162a"
import script from "./StepperPasoDescuentos.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperPasoDescuentos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports